<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            message:
                "Vous devriez avoir reçu le code. Veuillez vérifier votre e-mail.",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
defineProps<{
    user: { _id?: string; username?: string } | null
}>()

/** Payload émis après validation du code (pour l'étape info). */
export type FormAuthFirstLoginConfirmationNextPayload = {
    validation: string
    idcompany?: string | null
    hascompany?: boolean
}

const emit = defineEmits<{
    (e: "next", payload: FormAuthFirstLoginConfirmationNextPayload): void
}>()

// ================================
// INTERACTIONS
// ================================
/** Après validation réussie : émet le payload pour l'étape info. */
function onValidationSuccess(result: {
    token?: string
    company?: { idcompany?: string }
    validationCode?: string
}): void {
    emit("next", {
        validation: result.validationCode ?? "",
        idcompany: result?.company?.idcompany ?? null,
        hascompany: !!result?.company,
    })
}
</script>

<template>
    <FormAuthValidationForm
        v-if="user"
        :user-id="user._id"
        :user-name="user.username"
        @validation-success="onValidationSuccess"
    >
        <template #header>
            <p class="text-sm text-surface-600 text-center">
                {{ t("message") }}
            </p>
        </template>
        <template #footer />
    </FormAuthValidationForm>
    <p v-else class="text-sm text-surface-600">
        Veuillez d'abord saisir votre e-mail pour recevoir le code de
        validation.
    </p>
</template>
